import script from "./KAMFormEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./KAMFormEdit.vue?vue&type=script&lang=ts&setup=true"

import "./KAMFormEdit.vue?vue&type=style&index=0&id=ad9118ca&scoped=true&lang=css"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad9118ca"]])

export default __exports__